import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { closeErrorMessage } from 'store/actions/ui.action'
import { useAppSelector } from 'store/useStoreHook'
import AlertDialog from './AlertDialog'

export default function ResponseErrorDialog() {
    const dispatch = useDispatch()
    const { open, message, arg, hideOKBtn, hideCloseBtn } = useAppSelector(
        (state) => state.ui.errorDialog,
    )

    const { t } = useTranslation()

    const handleOnClose = () => {
        dispatch(closeErrorMessage())
    }
    const messageBody = useMemo(() => {
        if (typeof message === 'string') return t(message, arg)
        return message
    }, [arg, message, t])
    return (
        <AlertDialog
            open={open}
            onClose={handleOnClose}
            title={t('dialog.warning')}
            hideOKBtn={hideOKBtn}
            hideCloseBtn={hideCloseBtn}
        >
            {messageBody}
        </AlertDialog>
    )
}
